var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "102406ff9c06cff945833bf4e37b57be72a20974"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dfh-corp-sites@designs-for-health"] = {
  id: "102406ff9c06cff945833bf4e37b57be72a20974"
};